
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/quick-start.md?type=demo')
};